const isBrowser = typeof window !== `undefined`;

export const setUser = (user) =>
  (window.localStorage.getbyUser = JSON.stringify(user));

const getProdecerUser = () => {
  if (window.localStorage.getbyUser) {
    const user = JSON.parse(window.localStorage.getbyUser);
    return user || {};
  }
  return {};
};

export const isLoggedIn = () => {
  if (!isBrowser) return false;

  const user = getProdecerUser();
  if (user) return !!user.username;
};

export const getCurrentUser = () => isBrowser && getProdecerUser();

export const logout = (callback) => {
  if (!isBrowser) return;
  setUser({});
  callback();
};
